import { proxy, subscribe, useSnapshot } from 'valtio';
import { playNotificationSound } from '../lib/playNotificationSound';
import { muteSoundNotificationStore } from '../hooks/useMuteSoundNotificationStore';
const notificationsStore = proxy({
    count: 0,
});
const setNotificationsCount = (count) => {
    notificationsStore.count = count;
};
export const useNotificationsStore = () => {
    const { count: notificationsCount } = useSnapshot(notificationsStore);
    return { notificationsCount, setNotificationsCount };
};
subscribe(notificationsStore, () => {
    if (notificationsStore.count === 0) {
    }
    else {
        if (!muteSoundNotificationStore.muted) {
            playNotificationSound();
        }
    }
});
